export default {
  convert(content) {
    content = content.replace(
      "Yoga Flow",
      "Yoga Flow<span class='special'>➁</span>"
    );
    content = content.replace(
      "Protein Joe",
      "Protein Joe<span class='special'>➁</span>"
    );
    return content;
  },

  go(content) {
    return {
      __html: this.convert(content)
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/render-html.js